module.exports = __webpack_public_path__ + "static/media/personTicket.70840f6f.svg";